import React from 'react';

// Hooks
import { useMousePosition } from './Hooks/useMousePosition';

// UI
import {
  IkigaiIcon,
  NameIconV4,
  QuoteIconV2,
  ValuesIcon,
  VisionIcon,
  VitIcon,
} from '../../ui/Icons/Icon';

// Utils
import { dateFormatter, continuationCalculator } from '../../../utils/UtilityFunctions';

// Styling
import './FloatingInfoPanel.css';

const FloatingInfoPanel = ({
  mouseState,
  viewType,
  meyear,
  cursorDisplayState,
  closeTooltip,
}) => {
  const { x, y } = useMousePosition(cursorDisplayState);

  const panelStyle = {
    display: cursorDisplayState ? 'block' : 'none',
    top: viewType === 'mobile' ? '5%' : `${y + 10}px`,
    left: viewType === 'mobile' ? '2.5%' : `${x + 15}px`,
  };

  const renderIcon = () => {
    switch (mouseState) {
      case 'me':
        return (<div className="panel-icon" onClick={closeTooltip}><VitIcon  /></div>

        );
      case 'values':
         return (
          <div className="panel-icon" onClick={closeTooltip}><ValuesIcon /></div>
         );
      case 'vision':
          return (
          <div className="panel-icon" onClick={closeTooltip}><VisionIcon /></div>
         );
      case 'ikigai':
     return (
          <div className="panel-icon" onClick={closeTooltip}><IkigaiIcon /></div>
         );
      case 'quote':
    return (
          <div className="panel-icon" onClick={closeTooltip}><QuoteIconV2 /></div>
         );
      default:
        return null;
    }
  };

  const renderContent = () => {
    if (!mouseState || !meyear || !meyear.obj) {
    return <p className="panel-body">Information not available.</p>;
  }

    switch (mouseState) {
      case 'me': {

        const birthday = meyear?.obj?.birthday;
const formattedDate = birthday && dateFormatter(birthday);
        const continuation = birthday && continuationCalculator(birthday);
        return (
          <p className="panel-body">
            I am <strong>{meyear.obj.name}</strong>. I was born on {formattedDate} and
            today is day {continuation} of my life.
          </p>
        );
      }
      case 'values':
        return (
          <div className="panel-grid">
            {Object.keys(meyear?.obj?.values ?? {}).map((key, index) => (
              <div key={index} className="panel-column">
                <h3 className="panel-subheading">{meyear.obj.values[key].title}</h3>
                <p className="panel-body-small">{meyear.obj.values[key].description}</p>
              </div>
            ))}
          </div>
        );
      case 'vision':
        return (
          <>
            {Object.keys(meyear.obj.vision).map((key, index) => (
              <p key={index} className="panel-body">{meyear.obj.vision[key].description}</p>
            ))}
          </>
        );
      case 'ikigai':
      case 'quote':
        return <p className="panel-body">"{meyear.obj[mouseState]}"</p>;
      default:
        return null;
    }
  };

  return (
    <div className="floating-info-panel-wrapper" style={panelStyle}>
      <div className="floating-info-panel">
        <div className="panel-content">{renderContent()}</div>
      </div>
      {renderIcon()}
    </div>
  );
};

export default FloatingInfoPanel;